import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FunnyLoaderService {
  private _isVisible = new BehaviorSubject<boolean>(false);
  private _currentText = new BehaviorSubject<string>('');
  private intervalId: any = null;
  private texts: string[] = [
    'Koeien uit de weide halen...',
    'Formulieren aan het uitprinten...',
    'Mest aan het verzamelen...',
    'Kalveren aan het tellen...',
    'Weiland aan het maaien...',
    'Stallen aan het schoonmaken...',
    'Melkmachines aan het aansluiten...',
    'Kalvervoeding bereiden...',
    'Technische data converteren...',
    'Resultaten analyseren...',
    'Grafieken genereren...',
    'Hooi uit de schuur halen...',
    'Slootwater aan het meten...'
  ];

  public get isVisible$(): Observable<boolean> {
    return this._isVisible.asObservable();
  }

  public get currentText$(): Observable<string> {
    return this._currentText.asObservable();
  }

  show(): void {
    this._isVisible.next(true);
    this.startChangingTexts();
  }

  hide(): void {
    this._isVisible.next(false);
    this.stopChangingTexts();
  }

  private startChangingTexts(): void {
    if (this.intervalId) {
      this.stopChangingTexts();
    }

    // Start met een willekeurige tekst
    this.setRandomText();

    // Verander elke 2 seconden van tekst
    this.intervalId = setInterval(() => {
      this.setRandomText();
    }, 2000);
  }

  private stopChangingTexts(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private setRandomText(): void {
    const randomIndex = Math.floor(Math.random() * this.texts.length);
    this._currentText.next(this.texts[randomIndex]);
  }
}
